import { render, staticRenderFns } from "./ObjectPermissions.vue?vue&type=template&id=3073d795"
import script from "./ObjectPermissions.vue?vue&type=script&setup=true&lang=ts"
export * from "./ObjectPermissions.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports